export default {
  title: 'Kontakt og synkronisering',
  labels: {
    occ_phone_number: 'Callcenterets telefonnummer',
    company_phone_number: 'Restaurantens telefonnummer',
    has_google_business_sync: 'Synkroniser med Google Business',
    has_foodamigos_sync: 'Synkroniser med Fooodamigos-tjenester',
  },
  placeholders: {
    occ_phone_number: 'Vælg telefonnummer fra listen',
  },
};
